module.exports = __webpack_public_path__ + "static/media/horizontalEllipsis.5a2bdd96.svg";